exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-b9872f12],html[data-v-b9872f12]{height:100%}img[data-v-b9872f12]{max-width:400px}", ""]);

// exports
